import { RowCrudStatus } from "../../common/types";
import { DashboardWidget } from "../../../api/graphql";
import { LangStore } from "../../../store";

export type DashboardWidgetValuesType = {
  id: string;
  displayId: string;
  version_: string;
  __status__: RowCrudStatus;
};

export type DashboardWidgetErrorsType = {};

export function DashboardWidgetValuesInit(): DashboardWidgetValuesType {
  return {
    id: "",
    displayId: "",
    version_: "",
    __status__: "empty",
  };
}

export type DashboardWidgetType = DashboardWidget | DashboardWidgetValuesType;

export function dashboardWidgetDisplayId(
  source: Partial<DashboardWidget>,
  _langStore: LangStore
) {
  return source.widgetKey ?? _langStore.emptyStringSymbol;
}

export function getDashboardWidgetValues(
  source: DashboardWidgetType,
  _langStore: LangStore,
  _duplicated: boolean = false
): DashboardWidgetValuesType {
  const entityValues = DashboardWidgetValuesInit();
  entityValues.id = source.id;
  entityValues.displayId =
    "__status__" in source
      ? source.displayId
      : dashboardWidgetDisplayId(source, _langStore);
  entityValues.version_ = source.version_;

  if (_duplicated) {
    entityValues.__status__ = "added";
  } else if ("__status__" in source) {
    entityValues.__status__ = source.__status__;
  }
  return entityValues;
}
